export default {
  'component.tagSelect.expand': '展開',
  'component.tagSelect.collapse': '折りたたむ',
  'component.tagSelect.all': 'すべて',

  // サイドバー折りたたみボタン
  'component.sider.collapse': 'ナビゲーションを折りたたむ',

  // IconPicker アイコン選択
  'component.iconPicker.placeholder': 'クリックしてアイコンを選択',
  'component.iconPicker.modalTitle': 'アイコンを選択',
  'component.iconPicker.searchPlaceholder': 'アイコンを検索',

  // MultiTab タブコンテキストメニュー
  'component.multiTab.refresh': '再読み込み',
  'component.multiTab.close': 'タブを閉じる',
  'component.multiTab.closeLeft': '左側のタブを閉じる',
  'component.multiTab.closeRight': '右側のタブを閉じる',
  'component.multiTab.closeOthers': '他のタブを閉じる',
  'component.multiTab.closeAll': 'すべてのタブを閉じる',

  // 图片上传
  'component.iconUpload.upload': 'アップロード',
  'component.iconUpload.uploadSucc': 'アップロード成功',
  'component.iconUpload.uploadFail': 'アップロード失敗',

  // ProFormSelectWithAll
  'component.proFormSelectWithAll.selectAll': 'すべて選択',
  'component.proFormSelectWithAll.unselectAll': '選択を解除'
};
